import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import DynamicCell from '../dynamic-cell';
import { CUSTOM_FIELD_TYPES } from '../god-table';
import styles from './styles.css';

function CustomFieldRenderer(props) {
  if (props.node.group) {
    // groupping
    return null;
  }
  const { customFieldType, column, data } = props;

  const targetObject = column.target_object;
  let targetId = null;
  let ids = [];

  if (customFieldType === CUSTOM_FIELD_TYPES.OPPORTUNITY) {
    if (targetObject === 'OpportunityCompetitor') {
      targetId = 'competitors';
    } else if (targetObject === 'Account') {
      targetId = 'account_id';
    } else if (targetObject === 'Product') {
      targetId = 'line_items';
    } else if (targetObject === 'User') {
      targetId = 'owner_id';
    } else if (targetObject === 'Opportunity') {
      targetId = 'opportunity_id';
    }
    if (!targetId) {
      return null;
    }
    if (targetId === 'competitors') {
      ids = map(data[targetId], 'id');
    } else if (targetId === 'line_items') {
      ids = map(data[targetId], 'product_id');
    } else {
      const hasId = data[targetId] !== undefined && data[targetId] !== null;
      ids = hasId ? [data[targetId]] : [];
    }
  } else if (customFieldType === CUSTOM_FIELD_TYPES.ACCOUNT) {
    if (targetObject === 'Account') {
      targetId = 'account_id';
    } else if (targetObject === 'User') {
      targetId = 'owner_id';
    }
    if (!targetId) {
      return null;
    }
    const hasId = data[targetId] !== undefined && data[targetId] !== null;
    ids = hasId ? [data[targetId]] : [];
  }

  const isList = ids.length > 1;
  if (isList) {
    return (
      <ul className={styles.customList}>
        {ids.map(i => (
          <li key={i} className={styles.listItem}>
            <DynamicCell
              id={i}
              column={column}
              localObject={data}
            />
          </li>
        ))}
      </ul>
    );
  }

  return (
    <DynamicCell
      id={ids[0]}
      column={column}
      localObject={data}
    />
  );
}

CustomFieldRenderer.propTypes = {
  column: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    description: PropTypes.string,
    is_system: PropTypes.bool,
    is_visible: PropTypes.bool,
    position: PropTypes.number,
    width: PropTypes.number,
    tag: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string, // meta type, int, double, date, bool, etc...
    target_object: PropTypes.string,
    target_field: PropTypes.string,
  }).isRequired,
  customFieldType: PropTypes.string.isRequired,
  data: PropTypes.shape({}),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
CustomFieldRenderer.defaultProps = {
  data: null,
  node: {},
};

export default CustomFieldRenderer;
